export default "__VITE_ASSET__Dk35Vdcy__"